import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

const checkoutDatadogData = pageProps => {
  if (!pageProps?.booking?.guest?.id) {
    return null;
  }

  return {
    ...(pageProps.booking?.booking
      ? {
          context: {
            bookingId: pageProps.booking.booking.id
          }
        }
      : {}),
    user: {
      id: pageProps.booking.guest.id,
      email: pageProps.booking.guest.profile.contacts.email_address
    }
  };
};

const offerDatadogData = pageProps => {
  if (!pageProps?.profile?.id) {
    return null;
  }

  return {
    context: {
      offerId: pageProps.offer.offerAggregate.id
    },
    user: {
      id: pageProps.profile.id,
      email: pageProps.profile.profile?.contacts?.email_address
    }
  };
};

export const setDatadogData = (user, bookingId) => {
  user && datadogRum.setUser({ ...user });
  bookingId && datadogRum.setGlobalContext({ bookingId });
};

export const BUILD_PER_PAGE = {
  checkout: checkoutDatadogData,
  offer: offerDatadogData
};

export const buildDatadogData = (pageProps, page) => {
  return BUILD_PER_PAGE[page] ? BUILD_PER_PAGE[page](pageProps) : null;
};

export const handleDatadogError = (message, payload, error) => {
  try {
    datadogLogs.logger.error(message, payload, error);
  } catch (datadogError) {
    console.error(datadogError);
  }

  throw error;
};
